import { ConcreteEncodable } from "./ConcreteEncodable";

import { MarkupInfoImplEncoder } from "../../encoder/MarkupInfoImplEncoder";

import * as CubiqTS from "../../index";
import { MarkupInfo } from "../MarkupInfo";

export class MarkupInfoImpl extends ConcreteEncodable implements MarkupInfo {
  public static enType: string = "com.bcdfx.model.MarkupInfoImpl";

  /*FID=1*/
  public pips: CubiqTS.BigNumber | null = null;
  /*FID=2*/
  public points: CubiqTS.BigNumber | null = null;
  /*FID=3*/
  public markupQty: CubiqTS.BigNumber | null = null;
  /*FID=4*/
  public markupType: CubiqTS.MarkUpType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = MarkupInfoImplEncoder.Instance;
    this.setEncodableType(MarkupInfoImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "MarkupInfoImpl[" +
      "pips=" +
      this.pips +
      "points=" +
      this.points +
      "markupQty=" +
      this.markupQty +
      "markupType=" +
      this.markupType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
